/**
 * Chip component overrides.
 * Pill-shaped chips with smooth transitions.
 */

import type { Theme } from '@mui/material/styles';

const chip: Theme['components'] = {
  MuiChip: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body2,
        fontWeight: theme.typography.fontWeightMedium,
        borderRadius: 999,
        height: 28,
        transition: 'all 150ms ease',
        '&.MuiChip-sizeSmall': {
          height: 22,
          fontSize: '0.6875rem',
        },
        '&.Mui-disabled': {
          opacity: 0.45,
        },
      }),
    },
  },
};

export default chip;
